import {
  combineReducers
} from 'redux'

import greenlight from 'containers/Report/Greenlight/reducer'
import weeklystatus from 'containers/Report/WeeklyStatus/reducer'
import nvqual from 'containers/Report/Nvqual/reducer'
import dashboard from 'containers/Report/Dashboard/reducer'

export default combineReducers({
  greenlight,
  weeklystatus,
  nvqual,
  dashboard
})